<script setup>

import {computed, onMounted, reactive, ref} from "vue";

const reporting = reactive({
    reportableChannels: [],
});

const search = ref('')

const loadChannels = async () => {
    const res = await axios.get(route('community.admin.api.reporting.index'));

    reporting.reportableChannels = res.data.channels;
}

const filteredReportableChannels = computed(() => {
    return reporting.reportableChannels.filter(channel => {
        return channel.name.toLowerCase().includes(search.value.toLowerCase()) ||
            channel.community.name.toLowerCase().includes(search.value.toLowerCase());
    });
});

onMounted(() => {
    loadChannels();
});

</script>

<template>
    <div>
        <frosted-bar>
            <div class="flex items-center justify-between space-x-4">
                <h1>{{ _mft('community:reporting.channels.title') }}</h1>
            </div>
        </frosted-bar>

        <div class="mt-6">
            <div class="flex justify-end">
                <input-text
                    v-model:content="search"
                    :placeholder="_mft('shared:search')"
                    class="w-48"
                ></input-text>
            </div>

            <list-basic>
                <list-basic-item
                    v-for="(channel, c) in filteredReportableChannels"
                    :key="c"
                >
                    <div class="flex items-center justify-between gap-4">
                        <div class="flex flex-col">
                            <a class="mf-link" :href="route('community.admin.reporting.channel', channel.id)">
                                {{ channel.name }}
                            </a>
                            <span class="text-xs text-gray-400">{{ channel.community.name }}</span>
                        </div>
                        <a class="mf-link text-sm" :href="route('community.admin.reporting.channel-overview', channel.id)">
                            {{ _mft('community:reporting.overview.title') }}
                        </a>
                    </div>
                </list-basic-item>
            </list-basic>
        </div>

    </div>
</template>
